import * as types from "../../../../store/member/events/mutations";

export default {
    getUpcoming({commit, state}, memberHashedId) {
        if (state.upcoming.length) return;

        commit('SET_PROCESSING_STATE', true);

        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/events?type=summit,mcd&status=upcoming&relations[members]=${memberHashedId}`)
                .then(({ data }) => {
                    commit('UPDATE_UPCOMING_EVENTS', data.events.data);
                    resolve(data)
                })
                .catch(({response}) => reject(response))
                .done(_ => commit('SET_PROCESSING_STATE', false));
        });
    },

    getAttended({commit, state}, memberHashedId) {
        if (state.attended.length) return;

        commit('SET_PROCESSING_STATE', true);

        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/members/${memberHashedId}/events?status=attended`)
                .then(({ data }) => {
                    commit('UPDATE_ATTENDED_EVENTS', data.events.data);
                    resolve(data)
                })
                .catch(({response}) => reject(response))
                .done(_ => commit('SET_PROCESSING_STATE', false));
        });
    },

    getEvent({commit}, eventId) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.get(`/api/v1/member/events/${eventId}`)
                .then(({data}) => resolve(data.memberEvent.data))
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
}